import {createUseStyles} from 'react-jss'
import {
  CompanyModel,
  CompanyReportHistoryItemModel,
  CompanyReportModel
} from '../../redux/companyMonitorTypes';
import CompanyReportRepresentativeCard from "./CompanyReportRepresentativeCard";
import CompanyReportAmlReportCard from "./CompanyReportAmlReportCard";
import CompanyReportCreditReportCard from "./CompanyReportCreditReportCard";
import CompanyReportGeneralInfoCard from './CompanyReportGeneralInfoCard';
import CompanyReportTaxInfoCard from './CompanyReportTaxInfoCard';
import CompanyReportSignaturesCard from './CompanyReportSignaturesCard';
import CompanyReportChangeList from './CompanyReportChange/CompanyReportChangeList';
import Select from '../Select';
import {formatDateString} from '../../utils/dateHelper';

interface Props {
  report: CompanyReportModel
  company?: CompanyModel
  reportHistory?: CompanyReportHistoryItemModel[]
  onReportSelected?: (id: string) => void
}

const CompanyReport = ({report, company, reportHistory, onReportSelected}: Props) => {
  const styles = useStyles()

  const renderReportSelector = () => {
    if (!reportHistory) {
      return
    }

    return (
      <div className={styles.selectorWrapper}>
        <Select
          id='reportSelector'
          key='reportSelector'
          label=''
          options={reportHistory.map((historyItem) => {
            return {name: formatDateString(historyItem.date), value: historyItem.id}
          })}
          selectedValue={report.id}
          onSelect={(value) => onReportSelected && onReportSelected(value)}
        />
      </div>
    )
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h6>Cappy Monitor Report{reportHistory ? '' : ` ${formatDateString(report.date)}`}</h6>
        {renderReportSelector()}
      </div>

      <div className={styles.cardContainer}>
        <CompanyReportGeneralInfoCard report={report} company={company}/>
        <CompanyReportTaxInfoCard report={report}/>
        <CompanyReportSignaturesCard report={report}/>
        <CompanyReportCreditReportCard creditReport={report.creditReport}/>
        <CompanyReportAmlReportCard amlReport={report.amlReport}/>
      </div>

      <h6 className={styles.sectionHeading}>Representatives</h6>
      <div className={styles.cardContainer}>
        {report.representatives.map((representative, index) => (
          <CompanyReportRepresentativeCard key={index} representative={representative}/>
        ))
        }
      </div>

      <h6 className={styles.sectionHeading}>Changes since last report</h6>
      {report.changesSinceLastReport.length > 0
        ? <CompanyReportChangeList
            enableHandling={false}
            changes={report.changesSinceLastReport}/>
        : <p>No changes since last report.</p>
      }
    </div>
  )
}

export default CompanyReport

const useStyles = createUseStyles({
  container: {
    marginTop: 10
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 10,
    flexWrap: 'wrap',
    marginBottom: 15
  },
  sectionHeading: {
    marginTop: 25
  },
  selectorWrapper: {
    minWidth: 160,
    maxWidth: 240
  },
  cardContainer: {
    display: 'grid',
    // min() keeps the columns from overflowing the card on narrow screens.
    gridTemplateColumns: 'repeat(auto-fill, minmax(min(380px, 100%), 1fr))',
    gap: 10,
    marginBottom: 10
  }
})
